import React, { useState } from "react"
import { View, StyleSheet, LayoutChangeEvent } from "react-native"
import SliderArrows from "../assets/charity-flow/slider-arrows.svg"
import { GestureHandlerRootView, GestureDetector, Gesture } from "react-native-gesture-handler"
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withSpring,
  runOnJS,
} from "react-native-reanimated"
import { Text } from "./Typography.tsx"

type SliderProps = {
  onSlideRight: () => Promise<void>
  title?: string
  disabled?: boolean
  testID?: string
}

const BALL_WIDTH_OFFSET = 68

export const Slider = ({
  onSlideRight,
  title = "Slide to donate",
  disabled,
  testID,
}: SliderProps) => {
  const offset = useSharedValue(0)
  const [sliderWidth, setSliderWidth] = useState(0)

  const handleLayout = (event: LayoutChangeEvent) => {
    const { width } = event.nativeEvent.layout
    setSliderWidth(width)
  }

  async function handleSlideRight() {
    try {
      await onSlideRight()
    } finally {
      offset.value = withSpring(0, {
        damping: 100,
      })
    }
  }

  const pan = Gesture.Pan()
    .onChange((event) => {
      if (disabled) {
        return
      }
      if (Math.abs(offset.value) <= sliderWidth) {
        if (offset.value + event.changeX <= 0) {
          offset.value = 0
        } else if (offset.value + event.changeX >= sliderWidth - BALL_WIDTH_OFFSET) {
          offset.value = sliderWidth - BALL_WIDTH_OFFSET
        } else {
          offset.value = offset.value + event.changeX
        }
      }
    })
    .onFinalize(() => {
      if (offset.value >= sliderWidth * 0.7) {
        offset.value = withSpring(sliderWidth - BALL_WIDTH_OFFSET, {
          damping: 100,
        })
        runOnJS(handleSlideRight)()
        return
      }
      offset.value = withSpring(0, {
        damping: 100,
      })
    })

  const sliderStyle = useAnimatedStyle(() => {
    return {
      transform: [{ translateX: offset.value }],
    }
  })

  return (
    <GestureHandlerRootView style={{ opacity: disabled ? 0.5 : 1 }}>
      <View
        style={styles.sliderTrack}
        onLayout={handleLayout}
        testID={testID ? `${testID}Track` : undefined}
      >
        <GestureDetector gesture={pan}>
          <Animated.View
            style={[styles.sliderHandle, sliderStyle]}
            testID={testID ? `${testID}Handle` : undefined}
          >
            <SliderArrows />
          </Animated.View>
        </GestureDetector>
        <Text
          fontFamily="IBMPlexSans-Medium"
          fontSize={20}
          lineHeight={26}
          color="white"
          align="center"
        >
          {title}
        </Text>
      </View>
    </GestureHandlerRootView>
  )
}

const styles = StyleSheet.create({
  sliderTrack: {
    width: "100%",
    height: 66,
    backgroundColor: "#3B58E3",
    borderRadius: 100,
    justifyContent: "center",
    padding: 5,
  },
  sliderHandle: {
    width: 58,
    height: 58,
    backgroundColor: "#f8f9ff",
    borderRadius: 100,
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    left: 5,
    zIndex: 10,
  },
})
